<template>
  <div class="bmvform">
    <div class="successful"><p><b>Thank you for contacting Visible.</b><br />We'll be in touch soon.</p></div>
    <div class="failure"><p><b>ERROR: Oops! This is embarassing</b><br />Something went wrong with your submission.  Please email us at <a href="mailto:info@bemorevisible.com">info@bemorevisible.com</a>.</p></div>
    <h1>Contact Us</h1>
    <form class="contact_form" action="https://formspree.io/info@bemorevisible.com" method="POST">
      <div class="field">
        <input type="text" name="name" required>
        <label>Name</label>
      </div>
      <div class="field">
        <input type="email" name="_replyto" v-model="email"  required :class="{ notempty : email != '' }">
        <label >Email</label>
      </div>
      <div class="field">
        <textarea name="message" required></textarea>
        <label>Message</label>
      </div>
      <button class="submit"><div class="submit--text">Submit</div><div class="working"><icon name="spinner" scale="2" class="fa fa-spinner fa-2x"></icon></div></button>
    </form>
    
  </div>
</template>

<style lang="scss" scoped>
h1 {
  color:black;
  font-size:34px;
  text-align:center;
}
.bmvform {
  position:relative;
   padding:40px;
  background: white;
  box-shadow:8px 8px 0px rgba(0,0,0,0.2);
  font-size:24px;
  a {
    color:black;

  }
  p {
    margin:20px 0px;
  }
}
.successful.on, .failure.on {
  display:block;
}
.successful {
  // text-align:center;
  position:absolute;
  display:none;
}
.failure {
  // text-align:center;
  position:absolute;
  display:none;
}
label {
  position:absolute;
  top:15px;
  left:10px;
  z-index: 2;
  font-size:20px;
  color:#ccc;
  transition: all 200ms linear;
  pointer-events: none;
}
.field {
  position:relative;

}
input {
  height:50px;
  border:1px solid #999;
}
textarea {
  height:200px;
  border:1px solid #999;
}
input, textarea {
  width:100%;
  padding:10px;
  font-size:18px;
  margin-bottom:0px;
  &:focus, &:valid, &.notempty {
    & ~ label {
      top:0px;
      left:auto;
      right:10px;
      font-size:16px;
    }
  }
}
.submitting {
  .submit {
    pointer-events: none;
  }
  .submit--text {
    display:none;
  }
  .working {
    display:block;
  }
  input,textarea {
    pointer-events: none;
    opacity:0.5;
  }
}
.submitted {
  pointer-events: none;
  opacity:0.5;
  transition: all 1000ms ease-out;
  transform: translateY(-200%) translateX(200%) rotate(80deg) scale(0,0);
}
.submit {
  position:relative;
  background-color:#fff;
  border:1px solid #999;
  // box-shadow:5px 5px 0px rgba(0,0,0,0.2);
  color:#999;
  width:80px;
  height:40px;
  // cursor:not-allowed;
}
form:valid {
  .submit {
    color:#000;
    cursor:pointer;
  }
}
.working {
  display:none;
  .fa-icon {
    animation: SPIN 1000ms linear infinite;
  }
}
@keyframes SPIN {
  0% {
    transform: rotate(0deg);
  }
  
  100% {
    transform: rotate(360deg);
  }
}

</style>
<script>

export default {
  name: 'bmv-form',
  data: function () {
  	return { email: ''
	  }
  },
  mounted() {
    this.email = ''
    var form = document.querySelector('.contact_form')

    // Append the form status

    // var formStatus = document.createElement('div')
    // formStatus.setAttribute('class', 'form-status alert')
    // form.appendChild(formStatus)
    form.onsubmit = function (e) {
      // Stop the regular form submission
      e.preventDefault()
      form.classList.add('submitting')
      // Collect the form data while iterating over the inputs
      var data = {}
      for (var i = 0, ii = form.length; i < ii; ++i) {
        var input = form[i]
        if (input.name) {
          data[input.name] = input.value
        }
      }

      // Construct an HTTP request
      var xhr = new XMLHttpRequest()
      xhr.open(form.method, form.action, true)
      xhr.setRequestHeader('Accept', 'application/json; charset=utf-8')
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')

      // Send the collected data as JSON
      xhr.send(JSON.stringify(data))

      // Callback function
      xhr.onloadend = function (response) {
        form.classList.remove('submitting')
        form.classList.add('submitted')
        if (response.target.status === 0) {
          
          // Failed XmlHttpRequest should be considered an undefined error.
          // formStatus.className += ' alert-danger'
          // formStatus.innerHTML = form.dataset.formError
          document.querySelector('.failure').classList.add('on')

        } else if (response.target.status === 400) {

          // Bad Request
          // formStatus.className += ' alert-danger'
          // formStatus.innerHTML = JSON.parse(responseText).error
          document.querySelector('.failure').classList.add('on')

        } else if (response.target.status === 200) {

          // Success
          // formStatus.className += ' alert-success'
          // formStatus.innerHTML = form.dataset.formSuccess
          document.querySelector('.successful').classList.add('on')

        }
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// Form.vue?6e025805